import { makeAutoObservable, runInAction } from "mobx";
import Album from "./Album.js";
import Group from "./Group.js";

const API_URL = import.meta.env.VITE_API_URL;

export default class AlbumStore {
    _albumlist;
    _groupList;
    _albumOfTheDay;
    _previewAlbum;
    _isLoaded;
    constructor() {
        this._albumlist = [];
        this._groupList = [];
        this._albumOfTheDay = null;
        this._previewAlbum = null;
        this._isLoaded = {
            album: false,
            group: false,
            albumOfTheDay: false,
        };
        makeAutoObservable(this);
        this.loadGroup();
        this.loadAlbum();
        this.loadAlbumofTheDay();
    }

    // ACCESSEURS
    get albumList() {
        return this._albumlist;
    }
    get groupList() {
        return this._groupList;
    }
    get albumOfTheDay() {
        return this._albumOfTheDay;
    }
    get previewAlbum() {
        return this._previewAlbum;
    }
    get isLoaded() {
        return this._isLoaded;
    }

    set previewAlbum(previewAlbum) {
        this._previewAlbum = previewAlbum;
    }
    
    // CALCULATED VALUE
    get albumCount() {
        return this._albumlist.length
    }
    get groupNameList() {
        return this._groupList.map(({name})=>name);
    }
    get randomOrderAlbumList() {
        return [...this._albumlist].sort(() => Math.random() - 0.5);
    }

    // METHODS
    // async loadAlbum() {
    //     try {
    //         const response = await fetch("https://66350f479bb0df2359a3b1e9.mockapi.io/artworks");
    //         const responseJson = await response.json();

    //         // Create artworks
    //         this._albumlist = responseJson.map((album) => new Album(album))
    //         this._isLoaded = true;
    //         runInAction(() => {
    //             this._albumlist = responseJson.map((album) => new Album(album))
    //             this._isLoaded = true;
    //         });
    //     } catch(error) {
    //         throw new Error("Erreur de chargement" + error);
    //     }
    // }

    async loadGroup() {
        try {
            const response = await fetch(API_URL+"/groups"); // chemin relatif vers le fichier JSON
            const responseJson = await response.json();
            runInAction(() => {
                this._groupList = responseJson.map((group) =>
                    new Group({
                        id: group._id,
                        name: group.name,
                        presentation: group.presentation,
                        youtube: group.youtube
                    })
                );
                console.log(this._groupList);
                this._isLoaded.group = true;
            });
        } catch (error) {
            throw new Error("Erreur de chargement depuis le fichier JSON GROUP : " + error);
        }
    }

    // LOAD
    async loadAlbum() {
        try {
            const response = await fetch(API_URL+"/albums?limit=300"); // chemin vers le albumlist
            const responseJson = await response.json();
    
            runInAction(() => {
                this._albumlist = responseJson.data.map((album) =>
                    new Album({
                        albumTitle: album.title,
                        groupId: album.groupId,
                        dateAlbum: album.date,
                        imageUrl: album.image
                    })
                );
                console.log(this._albumlist);
                this._isLoaded.album = true;
            });
        } catch (error) {
            throw new Error("Erreur de chargement depuis le fichier JSON ALBUM : " + error);
        }
    }

    async loadAlbumofTheDay() {
        try {
            const response = await fetch(API_URL+"/album-of-the-day"); // chemin vers le album of the day
            const responseJson = await response.json();
            runInAction(() => {
                this._albumOfTheDay = 
                    new Album({
                        id: responseJson.id,
                        albumTitle: responseJson.title,
                        groupId: responseJson.groupId,
                        dateAlbum: responseJson.date,
                        imageUrl: responseJson.image
                    });
                this._isLoaded.albumOfTheDay = true;
            });
        } catch {
            throw new Error("Aucun Album of the Day trouvé")
        }
    }

    // GET BY
    getGroupById(id) {
        return this._groupList.find((group)=>group.id===id);
    }
    getAlbumById(id) {
        return this._albumlist.find((album)=>album.id===id);
    }

    groupListSorted({type = "alphabetical"}={}) {
        if (type==="alphabetical") {
            return [...this._groupList].sort((a, b) => a.name.localeCompare(b.name))
        }
    }

    getNumberAlbumGroup({ groupId }) {
        return this._albumlist.reduce((count, album) => album.groupId === groupId ? count + 1 : count, 0);
    }
    
    getAlbumsByGroup({groupId}) {
        return this._albumlist.filter((album)=>album.groupId===groupId);
    }


    // OTHER
    getRandomAlbumList({nbAlbum, groupId = ""}) {
        let filteredAlbumList = groupId
            ? this._albumlist.filter((album)=>album.groupId===groupId)
            : [...this._albumlist];
        // algorythme de Fisher Yates que j'ai trouvé pour mélanger un tableau
        for(let i = filteredAlbumList.length-1 ; i>0 ; i--) {
            const alea = Math.floor(Math.random() * (i + 1));
            [filteredAlbumList[i],filteredAlbumList[alea]] = [filteredAlbumList[alea],filteredAlbumList[i]];
        }
        return filteredAlbumList.slice(0, nbAlbum);
    }

    getGroupActivityPeriod(groupId) {
        const albums = this.getAlbumsByGroup({ groupId });
    
        if (albums.length === 0) {
            return "Aucun album connu pour ce groupe.";
        }
    
        const dates = albums
            .map(a => new Date(a.dateAlbum))
            .sort((a, b) => a - b);
        const firstYear = dates[0].getFullYear();
        const lastYear = dates[dates.length - 1].getFullYear();
    
        if (firstYear === lastYear) {
            return `Le groupe a sorti des albums en ${firstYear}.`;
        } else {
            return `Le groupe est actif entre ${firstYear} et ${lastYear}.`;
        }
    }
    
    
    async getSoundUrl({ id }) {
        try {
            const album = this.getAlbumById(id);
            if (!album) throw new Error("Album introuvable");
        
            const group = this.getGroupById(album.groupId);
            if (!group) throw new Error("Groupe introuvable");
    
            const artistQuery = encodeURIComponent(group.name);
            const albumQuery = encodeURIComponent(album.albumTitle);
            const url = `${API_URL}/deezer-search?artist=${artistQuery}&album=${albumQuery}`;
    
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error(`Erreur HTTP ${response.status}`);
            }
    
            const result = await response.json();
            if (result && Array.isArray(result) && result.length > 0) {
                const track = result[0];
                if (track.preview) {
                    console.log("track");
                    console.log(track);
                    return {
                        url: track.preview,
                        title: track.title_short || track.title || "Titre inconnu"
                    };
                } else {
                    throw new Error("Aucun extrait sonore disponible pour ce titre");
                }
            } else {
                throw new Error("Aucun résultat trouvé");
            }
        } catch (error) {
            console.error("Erreur lors de la récupération du son :", error);
            throw new Error("Erreur lors de la récupération du son : " + error.message);
        }
    }
    
    
    // PREVIEW ALBUM
    addPreviewAlbum(albumData) {
        this._previewAlbum = new Album(albumData);
    }
    clearPreviewAlbum() {
        this._previewAlbum = null;
    }
}

